export const EmptyState = ({ icon, title, text, action }) => (
  <div className="ds-empty">
    {icon && <div className="pc-empty-ico">{icon}</div>}
    {title && <div className="ds-empty-title">{title}</div>}
    {text && <div className="ds-empty-text">{text}</div>}
    {action && <div style={{ marginTop: 12 }}>{action}</div>}
  </div>
)

export const ErrorState = ({ title = "Couldn't load this page", text, action }) => (
  <div className="ds-error" role="alert">
    <div className="ds-error-title">{title}</div>
    {text && <div className="ds-error-text">{text}</div>}
    {action && <div style={{ marginTop: 12 }}>{action}</div>}
  </div>
)

export default EmptyState
